import React, { useState } from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import guangbin_dong from "../../Assets/Images/guangbin_dong.jpg";
import group216 from "../../Assets/Images/Group 216.png";
import { Dialog } from "primereact/dialog";
import Iframe from "react-iframe";
import bossbannser from "../../Assets/Images/LDO-Mailing-BOSS-2026-1.jpg";
import "./Home.css";
import playIcon from "../../Assets/svg/Play.svg";
import playHover from "../../Assets/svg/Play_hover.svg";

function Home() {
  const [visible, setVisible] = useState(false);
  const [hovered, setHovered] = useState(false);
  return (
    <div className="Main-Content pb-5">
      <Container fluid className="custom-minwidth">
        <section className="home-info">
          <Dialog
            header="Highlights from the BOSS XVIII Symposium"
            visible={visible}
            style={{ width: "60vw" }}
            onHide={() => {
              if (!visible) return;
              setVisible(false);
            }}
          >
            <Iframe
              url="https://players.brightcove.net/3198958923001/R4BQtXMAE_default/index.html?videoId=6376915754112"
              width="740px"
              height="427px"
              id=""
              className=""
              display="block"
              position="relative"
            />
          </Dialog>
          <div className="d-flex">
            <div className="info-left">
              <div className="video-section pt-4 pe-5 d-flex">
                <div className="left-video w-50 position-relative">
                  <img
                    src={playHover}
                    onClick={() => setVisible(true)}
                    onMouseLeave={() => setHovered(false)}
                    className={`position-absolute top-50 start-50 translate-middle ${hovered ? "d-block" : "d-none"}`}
                    style={{ width: "50px", height: "50px", cursor: "pointer" }}
                    alt="Play"
                  />
                  <img
                    src={playIcon}
                    onMouseEnter={() => setHovered(true)}
                    className={`position-absolute top-50 start-50 translate-middle ${hovered ? "d-none" : "d-block"}`}
                    style={{ width: "50px", height: "50px", cursor: "pointer" }}
                    alt="Play Hover"
                  />
                  {/* <img width={270} height={175} onClick={() => setVisible(true)} src={require(`../../Assets/Images/Video_thumbnail.png`)} alt="Highlights from the BOSS XVIII Symposium"></img> */}
                </div>
                <div className="right-video w-50">
                  <p className="p-4 text-white">
                    Highlights from the BOSS XVIII Symposium
                  </p>
                </div>
              </div>
              <div className="aboutprize-block pt-4 pe-5">
                <h4 className="pt-3">About the prize</h4>
                <p>
                  {" "}
                  The{" "}
                  <span>
                    Janssen Prize for Creativity in Organic Synthesis{" "}
                  </span>{" "}
                  was
                  <Link className="historyLink" to="/history">
                    {" "}
                    established in 1986
                  </Link>{" "}
                  by Janssen Pharmaceuticals, members of the academic chemistry
                  community and the
                  <a
                    className="historyLink"
                    href="https://www.boss-symposium.org/"
                  >
                    {" "}
                    Belgian Organic Synthesis Symposium (BOSS)
                  </a>{" "}
                  to bring attention to the positive impact of organic synthesis
                  in drug discovery.
                </p>
                <div className="Container">
                  <ul>
                    <li>
                      This prestigious recognition is awarded every two years to
                      a chemist, under the age of 50, who has made a significant
                      contribution to the field of organic synthesis
                    </li>
                    <li>
                      Nominations are submitted by the global academic community
                      of organic chemists
                    </li>
                    <li>
                      A panel of
                      <Link className="historyLink" to="/jury">
                        {" "}
                        international jury members
                      </Link>
                      , chaired by Prof. B. Feringa, 2016 Nobel Prize winner,
                      select the winner.
                    </li>
                    <li>
                      The recipient receives 20.000 Euros, a trophy, a plaque
                      and delivers a keynote address at BOSS.
                    </li>
                  </ul>
                </div>
                <div className="Container d-flex align-items-center">
                  <img alt="group216" className="group216" src={group216}></img>
                  <div className="ps-4">
                    <p className="">
                      Learn more about our 30-year legacy
                      <Link className="historyLink" to="/history">
                        {" "}
                        established in 1986{" "}
                      </Link>
                      and our impressive winners
                      <Link className="historyLink" to="/winners">
                        {" "}
                        here.
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="info-right">
              {/* <div className="nomination-block">
                                <h4>Call for Nominations!</h4>
                                <p>We are pleased to announce the <span>“Call for Nominations”</span> for
                                    the 2026 Janssen Prize for Creativity in Organic Synthesis. Submission
                                    deadline is December 31, 2025. Further details on the nomination process can be
                                    found <Link className="historyLink" to="/nominations"> here</Link>.
                                    <br /> <br /> The 2026 Janssen Prize will be announced at the
                                    <a target="_blank" className="historyLink" rel="noreferrer" href="https://www.boss-symposium.org/"> BOSS XIX Symposium </a>.                                    
                                </p>
                            </div> */}

              <div className="winner-block mt-2 pt-2">
                <h4>Congratulations to our 2026 winner!​</h4>
                <div className="winner-sub d-flex">
                  <div className="winner-sub-image me-3">
                    <img
                      alt="guangbin_dong"
                      className="guangbin_dong mb-3"
                      src={guangbin_dong}
                    ></img>
                    <p>
                      <span>Professor Guangbin Dong​</span>
                      <br /> Weldon G. Brown <br /> Professor of Chemistry <br /> University of Chicago
                    </p>
                  </div>
                  <div className="winner-sub-content">
                    <p>
                      Prof. Guangbin Dong is a leading scientist in the fields of organic synthesis and catalysis. This prize recognizes
                      his accomplishments in developing novel transition metal-catalyzed synthetic methods for the activation of inert chemical bonds. His pioneering and sustainable approaches on activation of carbon-carbon bonds have offered substantial inspirations for precise and controlled manipulations of molecular skeletons.
                    </p>
                    <p>
                      Prof. Dong will be awarded at the{" "}
                      <a
                        className="historyLink"
                        href="https://www.boss-symposium.org/"
                      >
                        {" "}
                        BOSS XIX{" "}
                      </a>{" "}
                      in Leuven, Belgium (5-10 July, 2026) and deliver a keynote lecture.
                    </p>
                    
                  </div>
                </div>
              </div>

              <div className="Boss_Banner pt-2">
                <img
                  alt="bossbannser"
                  className="bossbannser"
                  src={bossbannser}
                ></img>
              </div>
            </div>
          </div>
        </section>
      </Container>
    </div>
  );
}

export default Home;